import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    buttonLabelNo: 'No',
    buttonLabelYes: 'Yes',
    nextButtonLabel: 'Continue',
    required: 'This field is required',
    sectionLabelFiscalResidence:
      'Do you have tax residency in any country other than France?',
    sectionLabelUsCitizen:
      'Are you a citizen or tax payer in the United States? (US Person)',
    title: 'Do you pay taxes abroad?',
  },
  fr: {
    buttonLabelNo: 'Non',
    buttonLabelYes: 'Oui',
    nextButtonLabel: 'Continuer',
    required: 'Vous devez répondre à cette question pour continuer',
    sectionLabelFiscalResidence:
      'Avez-vous une résidence fiscale dans un autre pays que la France\u00A0?',
    sectionLabelUsCitizen:
      'Avez-vous la citoyenneté américaine ou payez-vous des impôts aux États-Unis (US person)\u00A0?',
    title: 'Payez-vous des impôts à l’étranger\u00A0?',
  },
});
